export default __webpack_public_path__ + "static/media/PancakeSwap.d9e69775.webp";